var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MyADGTransparency.jinja');
require('./MyADGTransparency.less');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MyADGTransparency-showMoreButton': 'onClickMoreButton'
    },


    initialize: function (options) {
        this.options = options || {};


        Base.prototype.initialize.call(this, options);
    },


    onClickMoreButton: function (e) {
        this.$el.toggleClass('MyADGTransparency--expanded');



        if (this.$el.hasClass('MyADGTransparency--expanded')) {
            this.$('.MyADGTransparency-others').slideDown(500);
        } else {
            this.$('.MyADGTransparency-others').slideUp(500);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MyADGTransparency/MyADGTransparency.js
// module id = 231
// module chunks = 0